export const defaultText = ` # React Markdown Editor 
  \n ### This is sample Markdown for demo purposes 
  \n - **how to be bold**
  \n - *or speak italian*
  \n 1. I have added a few hints on the bottom on some basic Markdown.
  \n 2. Feel free to edit this text or add your own instead.
  \n       - *Enjoy*
   `
